import {IQuiz} from "@/util/service/quiz/IQuiz";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {Box, Button, Dialog, DialogContent, DialogTitle, Pagination, TextField} from "@mui/material";
import Stack from "@mui/material/Stack";
import {sanitizePurify} from "@/util/common/sanitize-html-purify";
import WysiwygEditor from "@/components/service/quiz/WysiwygEditor";
import React from "react";
import styled from "styled-components";
import {deepCopy} from "@/util/common/handle-object";

const QuizDownloaderDialog = (props: {
  setIsOpened: Function,
  quiz: IQuiz,
}) => {

  const quizCopy = deepCopy(props.quiz);
  delete quizCopy.quizId;
  const quizCopyText = JSON.stringify(quizCopy, null, 0);

  return (<Dialog open={true}
                 fullScreen={true}
                 sx={{pr: 0, pl: 1}}>

    <TitleContainer>
      <ArrowBackIosNewIcon sx={{mr: 0}} onClick={() => {
        props.setIsOpened(false);
      }}/>
      <DialogTitle sx={{fontWeight: 'bold', mr: 10}}>
        Quiz Downloader
      </DialogTitle>
    </TitleContainer>
    <DialogContent sx={{paddingTop: 1}}>

      <Box display="flex" gap={2}>
        <TextField
          variant="outlined"
          disabled
          value={quizCopyText}
          multiline
          rows={2}
          sx={{ width: '70%' }}
        />
        <Button variant={'contained'}
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(quizCopyText);
                  } catch (err) {
                    alert('copy error');
                  }
                }}
                component='label'>
          <ContentCopyIcon />
        </Button>
      </Box>

    </DialogContent>
  </Dialog>);
}


const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;


export { QuizDownloaderDialog }
